import React from 'react';
import useWebViewData from '@hooks/useWebViewData';
import CloseIcon from '@assets/CloseIcon';

import './BackToWebviewButton.css';

export default function BackToWebviewButton({ className }) {
  const data = useWebViewData();

  const onBackToWebView = () => {
    window.open(data.referer, '_self');
  };

  if (!data.mobile) {
    return null;
  }
  return (
    <button type="button" onClick={onBackToWebView} className={`buttonWrapper ${className}`}>
      <CloseIcon />
    </button>
  );
}
